import Vue from 'vue';
import PasswordForm from '@/components/pages/ChangePasswordPage/PasswordForm.vue'

Vue.component('password-form', PasswordForm);
